import React, { Component } from "react";
import Radio from "./../../../common/Radio/Radio";
import { Button } from "../../../common/Button/Button";
// import { getStatesMaster } from "../../../utils/localStorage";
import find from "lodash/find";
import sortBy from "lodash/sortBy";
import uniqueId from "lodash/uniqueId";

import RequestStateUpdateModal from "./RequestStateUpdateModal";
import Spinner from "../../../common/Spinner/Spinner";
import { URL_CALCULATOR } from "../../../utils/urls";
import { toast } from "react-toastify";
import ConfirmationModalSmall from "../../../components/ServicePackaging/ConfirmationModalSmall";

class RequestStateUpdateDropdown extends Component {
	constructor(props) {
		super(props);
		this.state = {
			listOpen: false,
			headerTitle: this.props.title,
			currentProgressionOrder: 0,
			recalculateURL: null,
		};
	}

	componentDidMount() {
		const currentProgressionOrder = this.getProgressionOrder(
			this.props.currentState
		);
		this.setState({ currentProgressionOrder });
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (this.props.currentState !== nextProps.currentState) {
			const currentProgressionOrder = this.getProgressionOrder(
				nextProps.currentState
			);
			this.setState({ currentProgressionOrder });
		}
	}

	// componentDidUpdate() {
	//   const { listOpen } = this.state;
	//   setTimeout(() => {
	//     if (listOpen) {
	//       window.addEventListener("click", this.close);
	//     } else {
	//       window.removeEventListener("click", this.close);
	//     }
	//   }, 0);
	// }

	componentWillUnmount() {
		window.removeEventListener("click", this.close);
	}

	close = (e) => {
		if (
			e.target.id === "openNEFTDropdownLPM" ||
			e.target.id === "lpmNEFTCancel" ||
			e.target.id === "lpmNEFTSave" ||
			e.target.id === "lpmNEFTCloseButton"
		) {
			return;
		}

		if (
			e.target.id === "openSelectCatalogueLPM" ||
			e.target.id === "lpmCatalogueCancel" ||
			e.target.id === "lpmCatalogueSave" ||
			e.target.id === "lpmCatalogueCloseButton"
		) {
			return;
		}

		const currentProgressionOrder = this.getProgressionOrder(
			this.props.currentState
		);
		this.setState({
			listOpen: false,
			currentProgressionOrder,
		});
	};

	toggleList = () => {

		if(this.props.isDisabled==""&&this.props.disableConfirmAndSave=="")
		{
			if(this.props.isUnsavedData)
			{
				if(this.props.isAllFieldsArevallid)
				{
					this.props.toggleUnsavedDataModal();
				}
				else
				{
					toast(`Please fill all required fields before progressing the service.`,
					{
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				}
			}
			else
			{
				this.setState((prevState) => ({
					listOpen: !prevState.listOpen,
				}));
			}
		}
		else
		{
			this.setState((prevState) => ({
				listOpen: !prevState.listOpen,
			}));
		}
		
	};

	getProgressionOrder = (sSRState) => {
		const state = find(this.props.masterServiceRequestStates, { sSRState });
		return state ? state.nOrder : -1;
	};

	partialPendingOrder = () => {
		const { masterServiceRequestStates } = this.props;
		const state = find(masterServiceRequestStates, {
			sSRState: "Partial Payment Pending",
		});
		return state ? state.nOrder : -1;
	};

	paymentReceivedOrder = () => {
		const { masterServiceRequestStates } = this.props;
		const state = find(masterServiceRequestStates, {
			sSRState: "Payment Received",
		});
		return state ? state.nOrder : -1;
	};

	getPaymentLinkAndNeftView = (currentProgressionOrder) => {
		const nPackageInstanceId= this.props.nPackageInstanceId;
		const isDisabled =
			currentProgressionOrder >= this.paymentReceivedOrder();
		const isNeftDisabled =
			this.props.deliveryMode === "Self-Served" ||
			this.props.paymentMode === "No_Payment" ||
			this.props.paymentMode === "SP_paid_service";
		let isPaymentLinkDisabled =
			this.props.deliveryMode === "Self-Served" ||
			this.props.paymentMode === "No_Payment" ||
			this.props.paymentMode === "SP_paid_service" ||
			!this.props.catalogueId ||
			isDisabled;

			if((!isDisabled)&&nPackageInstanceId)
			{
				isPaymentLinkDisabled=false;
			}
		// const isNeftDisabled = currentProgressionOrder >= this.paymentReceivedOrder();
		let paymentStatus = "";
		if (this.props.paymentStatus === "Credit")
			paymentStatus = "Payment Received";
		else if (this.props.paymentStatus === "Failed")
			paymentStatus = "Payment Failed";
		else if (this.props.paymentStatus === "Payment Link Deactivated")
			paymentStatus = "Payment Link Deactivated";
		else if (this.props.paymentURL !== null)
			paymentStatus = "Payment Pending";
		else paymentStatus = "Not Sent";

		return (
			<div
				className="flex justify-content-around ml-1"
				style={{ flexDirection: "column" }}
				key={uniqueId()}
			>
				<div
					id="openNEFTDropdownLPM"
					className={`underlined-action ${
						isNeftDisabled && "disabled"
					}`}
					onClick={this.props.toggleNeftModal}
				>
					{this.props.isDisabled
						? "View NEFT Details"
						: "Add NEFT Details"}
				</div>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
					}}
				>
					{
						this.props.bCouponApplied&&this.props.dtCouponExpiryDate?
						(
							<>
								{
									new Date(this.props.dtCouponExpiryDate)<new Date()?
									(
										<div
											className={`underlined-action 
											${isPaymentLinkDisabled && "disabled"}`}
											onClick={this.props.toggleConfirmationModal}>
											Send Payment Link
										</div>
									):
									(
										<div
											className={`underlined-action 
											${isPaymentLinkDisabled && "disabled"}`}
											onClick={this.props.onSendPaymentLink}>
											Send Payment Link
										</div>
									)
								}
							</>		
						):
						(
							<div
								className={`underlined-action 
								${isPaymentLinkDisabled && "disabled"}`}
								onClick={this.props.onSendPaymentLink}>
								Send Payment Link
							</div>
						)
					}					
					<div
						className={`payment-color-label ${paymentStatus.replace(
							" ",
							""
						)} ${isPaymentLinkDisabled && "disabled"}`}
					>
						<small>
							<label>{paymentStatus}</label>
						</small>
					</div>
				</div>
			</div>
		);
	};

	getChooseCatalogueView = (currentProgressionOrder) => {
		const isDisabled =
			currentProgressionOrder >= this.paymentReceivedOrder();
		return (
			<div
				id="openSelectCatalogueLPM"
				className={`underlined-action ml-1 mt-1 mb-2 ${
					this.props.deliveryMode === "Self-Served" && "disabled"
				}`}
				key={uniqueId()}
				onClick={this.props.togglCatalogueModal}
			>
				{this.props.isDisabled
					? "View Selected Catalogue"
					: "Select Catalogue"}
			</div>
		);
	};

	isOptionDisabled = (state, currentProgressionOrder) => {
		const thresholdOrder = this.partialPendingOrder();
		if(state.sSRState === "Quotation Sent")
		{
			if(this.props.paymentMode != "SP_paid_service")
			{
				return true;
			}
		}

		if(!this.props.nPackageInstanceId)
		{
			if (
				state.sSRState === "Partial Payment Pending" ||
				state.sSRState === "Payment Received"
			) {
				if (
					this.props.paymentMode === "No_Payment" ||
					this.props.paymentMode === "SP_paid_service"
				) {
					return true;
				}
			}
		}
		if (currentProgressionOrder >= thresholdOrder) {
			if (state.nOrder < thresholdOrder) return true;
			return false;
		} else {
			return false;
		}
	};

	renderRequestStates = (currentProgressionOrder) => {
		const { masterServiceRequestStates } = this.props;
		const view = [];
		sortBy(masterServiceRequestStates, "nOrder").forEach((state, i) => {
			if (state.sSRState === "Partial Payment Pending") {
				const ctaView = this.getPaymentLinkAndNeftView(
					currentProgressionOrder
				);
				const catalogueView = this.getChooseCatalogueView(
					currentProgressionOrder
				);
				view.push(catalogueView);
				view.push(ctaView);
			}
			view.push(
				<Radio
					key={uniqueId()}
					name={state.sSRState}
					id={state.sSRState}
					disabled={
						this.isOptionDisabled(state, currentProgressionOrder) ||
						this.props.deliveryMode === "Self-Served" ||
						this.props.isDisabled === "disabled"
					}
					label={state.sSRState}
					checked={currentProgressionOrder >= state.nOrder}
					onClick={(event) => {
						//prevent pop-up from closing
						event.stopPropagation();
						this.setState({
							currentProgressionOrder: state.nOrder,
						});
					}}
					onChange={(event) => {
						//prevent pop-up from closing
						event.stopPropagation();
					}}
				/>
			);
		});
		return view;
	};

	getStateNameById = (order) => {
		const state = find(this.props.masterServiceRequestStates, {
			nOrder: order,
		});
		return state;
	};

	handleSave = () => {
		const state = this.getStateNameById(this.state.currentProgressionOrder);
		if (state) {
			this.props.onChangeState(state.sSRState);
		} else {
			console.error(
				"Invalid State. Are you sure you have access to this page?"
			);
		}
	};

	render() {
		const { listOpen, currentProgressionOrder } = this.state;
		// const currentProgressionOrder = this.getProgressionOrder(this.props.currentState);
		return (
			<div className={`state-update  `}>
				<div className="dd-header state-update ">
					<div
						className={`dd-header-title cursor-pointer ${
							this.props.currentState === "Cancelled"
								? "disable"
								: ""
						} `}
						onClick={() => this.toggleList()}
					>
						<u>
							STATUS:{" "}
							{this.props.currentState || (
								<small>
									<i>Status Unavailable</i>
								</small>
							)}
						</u>
					</div>
				</div>
				{/* <br></br> */}
				<div className="flex">
					<u>
						<span>
							<a
								className={`${
									this.props.invoiceURL ? "" : "disableLink"
								}`}
								href={this.props.invoiceURL}
								target="_blank"
							>
								Break-up
							</a>
						</span>
					</u>
					&nbsp; &nbsp; &nbsp;
					<u>
						<span>
							<a
								className={`${
									this.props.currentState ===
									"Payment Received"
										? "disableLink"
										: ""
								} ${
									this.props.catalogueMode !== "DYNAMIC"
										? "disableLink"
										: ""
								} ${
									this.props.paymentMode === "No_Payment"
										? "disableLink"
										: ""
								} ${
									this.props.paymentMode === "SP_paid_service"
										? "disableLink"
										: ""
								}`}
								href={this.props.recalculateURL}
								target="_blank"
							>
								Re-calculate
							</a>
						</span>
					</u>
				</div>

				{/* {listOpen && (
          <div className="dd-list state-update">
            <div>{this.renderRequestStates(currentProgressionOrder)}</div>
            <Button
              isSubmitting={
                this.props.deliveryMode === "Self-Served" ||
                this.props.isDisabled === "disabled"
              }
              onClick={this.handleSave}
            >
              Save
            </Button>
          </div>
        )} */}
				<RequestStateUpdateModal
					isLoading={this.props.isLoading}
					isOpen={listOpen}
					toggleModal={this.toggleList}
					renderMe={this.renderRequestStates(currentProgressionOrder)}
					deliveryMode={this.props.deliveryMode}
					isDisabled={this.props.isDisabled}
					handleSave={this.handleSave}
				/>

			<ConfirmationModalSmall
				message="The payment link with coupon code has expired. A full service payment link will be generated."
				isOpen={this.props.showConfirmationModal}
				toggleModal={this.props.toggleConfirmationModal}
				onPositive={this.props.onSendPaymentLink}
			/>
			</div>
		);
	}
}

export default RequestStateUpdateDropdown;
